module.exports = __webpack_public_path__ + "img/iphone.7a94c832.png";